import { useState, useMemo } from 'react';
import { getQualityStatus, getRates } from './utils';

const useCalendarEvents = items => {
    const [groupedItems, setGroupedItems] = useState({});

    // Utilizamos useMemo para memoizar el cálculo de eventos
    const events = useMemo(() => {
        const groupedEvents = items.reduce((acc, item) => {
            const date = new Date(item.date).toISOString().split('T')[0]; // Get date in YYYY-MM-DD format
            if (!acc[date]) {
                acc[date] = {
                    date,
                    count: 0,
                    qualities: {},
                    totalAvailability: 0,
                    lowestRate: Infinity,
                    products: [],
                };
            }
            acc[date].count += 1;
            const qualityStatus = getQualityStatus(item.validity, item.quality);
            const iconKey = qualityStatus.text;
            if (!acc[date].qualities[iconKey]) {
                acc[date].qualities[iconKey] = { ...qualityStatus, count: 0 };
            }
            acc[date].qualities[iconKey].count += 1;
            if (qualityStatus.text !== 'invalid_quality') {
                acc[date].totalAvailability += item.availability;

                // Calculate the lowest rate for an adult
                const rates = getRates(item.rates);
                if (rates !== 'noRates' && Array.isArray(rates)) {
                    const adultRates = rates?.filter(
                        rate => rate.personType === 10 && rate.personIndex === 1
                    );
                    if (adultRates.length > 0) {
                        const lowestRate = Math.min(
                            ...adultRates.map(rate => rate.aat)
                        );
                        acc[date].lowestRate = Math.min(
                            acc[date].lowestRate,
                            lowestRate
                        );
                    }
                }
            }
            acc[date].products.push(item);
            return acc;
        }, {});

        const formattedEvents = Object.values(groupedEvents).map(event => ({
            start: event.date,
            extendedProps: {
                count: event.count,
                qualities: event.qualities,
                totalAvailability: event.totalAvailability,
                lowestRate: event.lowestRate,
            },
        }));

        setGroupedItems(groupedEvents); // Actualizamos groupedItems con los valores agrupados
        return formattedEvents;
    }, [items]); // Solo se recalcula si los items cambian

    return { events, groupedItems };
};

export default useCalendarEvents;
